import request from '@/utils/request'

// 查询码上办-考试预约列表
export function listKsyyOld(query) {
  return request({
    url: '/web/msb/ksyyOld/list',
    method: 'get',
    params: query
  })
}
